const updatePlayerDuel = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'playerDuel') {
            const {
                playerId,
                playerStats: {
                    pitcher: {
                        id: opponentId
                    } = {},
                    stat
                } = {}
            } = data;
            const updatedPlayer = {
                opponents: {
                    ...state?.playerId?.opponents,
                    [opponentId]: {
                        ...stat
                    }
                }
            };
            return { ...state, [playerId]: updatedPlayer };
        }
    }
    return state;
};

export default updatePlayerDuel;
